import { Routes, Route } from "react-router-dom";

import Home from "./components/Home";          // ← move Home to its own file (recommended)
import OurCompany from "./components/OurCompany"; // ← move OurCompany to its own file

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/our-company" element={<OurCompany />} />
    </Routes>
  );
}